import React, { PropTypes } from 'react';
import SelectDistrict from '../../../a2i/js/containers/SelectDistrict';
import SelectSchool from '../../../a2i/js/containers/SelectSchool';
import SelectClassroom from '../../../a2i/js/containers/SelectClassroom';
import SelectTeacher from '../containers/SelectTeacher';
import { Link } from 'react-router';
import _ from 'lodash';
import '../../styles/Export';
import { propertyHasChanged } from '../../../a2i/js/lib/objectComparison';
import { CLASSROOM, DISTRICT, SCHOOL } from '../../../a2i/js/lib/constants';
import { TEACHER } from '../../../shared/js/lib/roles';

let Export = React.createClass({
	propTypes: {
		authToken: PropTypes.string,
		fetchTeachers: PropTypes.func.isRequired,
		selectedClassroom: PropTypes.object,
		selectedDistrict: PropTypes.object,
		selectedSchool: PropTypes.object,
		teachers: PropTypes.array
	},

	getInitialState: function() {
		return {
			// dateParameter can be 'observation_date' or 'created_at' - this is the column used to filter
			// by date on the observations table
			dateParameter: 'observation_date',
			// exportBy can be 'district', 'school', 'classroom', or 'teacher'
			exportBy: 'district',
			selectedTeacherId: null,
			startDate: null,
			endDate: null,
			shouldIncludeClickstream: true,
			shouldIncludeDuration: true,
			shouldIncludeFrequency: true,
			validationErrors: {}
		};
	},

	componentWillReceiveProps: function(newProps) {
		if (newProps.selectedClassroom && propertyHasChanged(newProps.selectedClassroom, this.props.selectedClassroom)) {
			this.props.fetchTeachers(newProps.selectedClassroom.id);
		}

		// If we only get one new teacher when fetching, select that teacher
		if (newProps.teachers && newProps.teachers.length === 1 && propertyHasChanged(newProps.teachers, this.props.teachers)) {
			this.setState({ selectedTeacherId: newProps.teachers[0].id });
		}
	},

	getValidationErrors: function() {
		let { shouldIncludeClickstream, shouldIncludeDuration, shouldIncludeFrequency } = this.state,
			validationErrors = {};

		if (!shouldIncludeClickstream && !shouldIncludeDuration && !shouldIncludeFrequency) {
			validationErrors.exportType = 'Please select at least one';
		} else {
			delete(validationErrors.exportType);
		}

		if (this.state.exportBy === 'district' && !this.props.selectedDistrict) {
			validationErrors.exportBy = 'Please select a district';
		} else if (
			this.state.exportBy === 'school' &&
			(!this.props.selectedDistrict || !this.props.selectedSchool)
		) {
			validationErrors.exportBy = 'Please select a district and school';
		} else if (
			this.state.exportBy === 'classroom' &&
			(!this.props.selectedDistrict || !this.props.selectedSchool || !this.props.selectedClassroom)
		) {
			validationErrors.exportBy = 'Please select a district, school, and classroom';
		} else if (
			this.state.exportBy === 'teacher' &&
			(
				!this.props.selectedDistrict ||
				!this.props.selectedSchool ||
				!this.props.selectedClassroom ||
				!this.state.selectedTeacherId
			)
		) {
			validationErrors.exportBy = 'Please select a district, school, classroom, and teacher';
		} else {
			delete(validationErrors.exportBy);
		}

		return validationErrors;
	},

	handleSubmit: function() {
		let validationErrors = this.getValidationErrors();
		this.setState({ validationErrors: validationErrors });

		if (Object.keys(validationErrors).length) {
			console.log('Validation error!');
			return false;
		} else {
			let {
				dateParameter,
				endDate,
				shouldIncludeClickstream,
				shouldIncludeDuration,
				shouldIncludeFrequency,
				startDate
			} = this.state;

			let { authToken } = this.props,
				exportType = '',
				url = '/api/observations/export?token=' + authToken + '&date_parameter=' + dateParameter;

			if (endDate) {
				url += '&end_date=' + endDate;
			}
			if (startDate) {
				url += '&start_date=' + startDate;
			}

			if (shouldIncludeDuration && !shouldIncludeFrequency) {
				exportType = 'duration';
			} else if (shouldIncludeDuration && shouldIncludeFrequency) {
				exportType = 'duration_and_frequency';
			} else if (!shouldIncludeDuration && shouldIncludeFrequency) {
				exportType = 'frequency';
			} else if (shouldIncludeClickstream) {
				exportType = 'clickstream';
			}

			url += '&type=' + exportType;

			if (this.state.shouldIncludeClickstream) {
				url += '&include_clickstream=true';
			}
			if (this.props.selectedDistrict) {
				url += '&district_id=' + this.props.selectedDistrict.id;
			}

			if (this.state.exportBy !== 'district') {
				if (this.props.selectedSchool) {
					url += '&school_id=' + this.props.selectedSchool.id;
				}

				if (this.state.exportBy !== 'school') {
					if (this.props.selectedClassroom) {
						url += '&classroom_id=' + this.props.selectedClassroom.id;
					}
					if (this.state.exportBy === 'teacher') {
						url += '&teacher_id=' + this.state.selectedTeacherId;
					}
				}
			}

			window.location.href = url;
		}
	},

	handleSelectTeacher: function(ev) {
		this.setState({ selectedTeacherId: parseInt(ev.target.value) });
	},

	handleFormChange: function(ev) {
		let newState = {};
		newState[ev.target.name] = ev.target.value;
		this.setState(newState);
	},

	getExportSelectionHTML: function() {
		switch (this.state.exportBy) {
			case SCHOOL:
				return (
					<div className="export-by-controls">
						<SelectDistrict />
						{ this.props.selectedDistrict ? (<SelectSchool />) : '' }
					</div>
				);
			case CLASSROOM:
				return (
					<div className="export-by-controls">
						<SelectDistrict />
						{ this.props.selectedDistrict ? (<SelectSchool />) : '' }
						{ this.props.selectedSchool ? (<SelectClassroom />) : '' }
					</div>
				);
			case TEACHER:
				return (
					<div className="export-by-controls">
						<SelectDistrict />
						{ this.props.selectedDistrict ? (<SelectSchool />) : '' }
						{ this.props.selectedSchool ? (<SelectClassroom />) : '' }
						{
							this.props.selectedClassroom ? (
								<SelectTeacher
									classroom={ this.props.selectedClassroom }
									selectedTeacherId={ this.state.selectedTeacherId }
								/>
							) : ''
						}
					</div>
				);
			case DISTRICT:
			default:
				return (
					<div className="export-by-controls">
						<SelectDistrict />
					</div>
				);
		}
	},

	handleChangeType: function(ev) {
		let newState = {};
		newState[ev.target.name] = ev.target.checked;
		this.setState(newState);
	},

	render: function() {
		return(
			<div className="export container">
				<h2>Export Observation Data</h2>
				<div className="export-by export-section">
					<h4>Export by</h4>
					<div className="btn-group">
						<button
							className={ this.state.exportBy === 'district' ? 'btn btn-default active' : 'btn btn-default' }
							onClick={ () => this.setState({ exportBy: 'district' }) }
						>
							District
						</button>
						<button
							className={ this.state.exportBy === 'school' ? 'btn btn-default active' : 'btn btn-default' }
							onClick={ () => this.setState({ exportBy: 'school' }) }
						>
							School
						</button>
						<button
							className={ this.state.exportBy === 'classroom' ? 'btn btn-default active' : 'btn btn-default' }
							onClick={ () => this.setState({ exportBy: 'classroom' }) }
						>
							Classroom
						</button>
						<button
							className={ this.state.exportBy === 'teacher' ? 'btn btn-default active' : 'btn btn-default' }
							onClick={ () => this.setState({ exportBy: 'teacher' }) }
						>
							Teacher
						</button>
					</div>
					{ this.getExportSelectionHTML() }
					{
						this.state.validationErrors.exportBy ? (
							<div className="validation-error">{ this.state.validationErrors.exportBy }</div>
						) : ''
					}
				</div>
				<div className="export-dates export-section">
					<h4>[Optional] Date range</h4>
					<div className="export-date-all-controls">
						<div className="btn-group">
							<button
								className={
									this.state.dateParameter === 'observation_date' ? 'btn btn-default active' : 'btn btn-default'
								}
								onClick={ () => this.setState({ dateParameter: 'observation_date' }) }
							>
								Instruction date
							</button>
							<button
								className={
									this.state.dateParameter === 'created_at' ? 'btn btn-default active' : 'btn btn-default'
								}
								onClick={ () => this.setState({ dateParameter: 'created_at' }) }
							>
								Coding date
							</button>
						</div>
						<div className="export-date-inputs">
							<div className="form-group">
								<label>Start date</label>
								<input
									className="form-control"
									name="startDate"
									type="date"
									value={ this.state.startDate }
									onChange={ this.handleFormChange }
								/>
							</div>
							<div className="form-group">
								<label>End date</label>
								<input
									className="form-control"
									name="endDate"
									type="date"
									value={ this.state.endDate }
									onChange={ this.handleFormChange }
								/>
							</div>
						</div>
					</div>
				</div>
				<div className="export-type export-section">
					<h4>Data to include</h4>
					<div className="checkbox">
						<label>
							<input
								type="checkbox"
								name="shouldIncludeDuration"
								checked={ this.state.shouldIncludeDuration }
								value="1"
								onChange={ this.handleChangeType }
							/>
							Duration
						</label>
					</div>
					<div className="checkbox">
						<label>
							<input
								type="checkbox"
								name="shouldIncludeFrequency"
								checked={ this.state.shouldIncludeFrequency }
								value="1"
								onChange={ this.handleChangeType }
							/>
							Frequency
						</label>
					</div>
					<div className="checkbox">
						<label>
							<input
								type="checkbox"
								name="shouldIncludeClickstream"
								checked={ this.state.shouldIncludeClickstream }
								value="1"
								onChange={ this.handleChangeType }
							/>
							Clickstream
						</label>
					</div>
					{
						this.state.validationErrors.exportType ? (
							<div className="validation-error">
								{ this.state.validationErrors.exportType }
							</div>
						) : ''
					}
				</div>
				<div className="export-controls">
					<Link
						className="btn btn-default btn-lg"
						to="/"
					>
						Cancel
					</Link>
					{' '}
					<button
						className="btn btn-lg btn-primary"
						onClick={ this.handleSubmit }
					>
						<i className="glyphicon glyphicon-download-alt" />{' '}Export
					</button>
				</div>
			</div>
		);
	}
});

module.exports = Export;



// WEBPACK FOOTER //
// ./frontend/olos/js/components/Export.jsx